import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Buttons — §3 of the Stage-2 sheet. One primary per view; the rest are quiet.
 *
 * The behaviour is React Aria's `Button`: press handling that works the same for mouse,
 * touch, pen and keyboard, `data-pressed` / `data-hovered` / `data-focus-visible` for the
 * sheet's states, and no 300ms tap delay or double-fire on touch. The pixels are still ours.
 */
import { Button as AriaButton } from 'react-aria-components';
export function Button({ tone = 'secondary', size = 'md', working = false, type = 'button', children, ...rest }) {
    const classes = ['btn', `btn-${tone}`, size === 'lg' ? 'btn-lg' : null].filter(Boolean).join(' ');
    return (_jsx(AriaButton, { ...rest, type: type, className: classes, "data-working": working ? 'true' : undefined, "aria-busy": working || undefined, children: children }));
}
//# sourceMappingURL=Button.js.map